import readXlsxFile from 'read-excel-file'

const getRowsFromExcelFile = async (file)=> {
    return await readXlsxFile(file)
}

export default getRowsFromExcelFile